import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './ComingSoon.css';
import logo from './logo.png';

// Social Icons
const TikTokIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
  </svg>
);

const InstagramIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
    <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
  </svg>
);

const LinkedInIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
  </svg>
);

// Translations
const translations = {
  EN: {
    comingSoon: 'Coming Soon',
    subtitle: 'We\'re building something amazing for students in Bahrain',
    giftFor: 'A gift for you',
    discount: '15%',
    off: 'OFF',
    firstSession: 'on your first session',
    autoApplied: 'This discount will be automatically applied when we launch',
    followUs: 'Follow us',
    backHome: 'Go to Homepage'
  },
  AR: {
    comingSoon: 'قريباً',
    subtitle: 'نبني شيئاً مميزاً للطلاب في البحرين',
    giftFor: 'هدية لك',
    discount: '15%',
    off: 'خصم',
    firstSession: 'على جلستك الأولى',
    autoApplied: 'سيتم تطبيق هذا الخصم تلقائياً عند الإطلاق',
    followUs: 'تابعنا',
    backHome: 'الذهاب للرئيسية'
  }
};

export default function ComingSoon() {
  const navigate = useNavigate();
  const [language] = useState(() => {
    const savedLang = localStorage.getItem('taealam_language');
    return savedLang === 'ar' ? 'AR' : 'EN';
  });

  const t = translations[language];
  const isRTL = language === 'AR';

  return (
    <div className={`cs-container ${isRTL ? 'rtl' : ''}`}>
      {/* Background Elements */}
      <div className="cs-bg-circle cs-bg-circle-1"></div>
      <div className="cs-bg-circle cs-bg-circle-2"></div>

      <div className="cs-content">
        {/* Logo */}
        <div className="cs-logo-wrap">
          <img src={logo} alt="Taealam" className="cs-logo" />
        </div>

        {/* Main Heading */}
        <h1 className="cs-title">{t.comingSoon}</h1>
        <p className="cs-subtitle">{t.subtitle}</p>

        {/* Discount Card */}
        <div className="cs-card">
          <div className="cs-card-badge">{t.giftFor}</div>
          <div className="cs-discount-row">
            <span className="cs-discount-num">{t.discount}</span>
            <span className="cs-discount-off">{t.off}</span>
          </div>
          <p className="cs-discount-desc">{t.firstSession}</p>
          <div className="cs-card-divider"></div>
          <p className="cs-card-note">{t.autoApplied}</p>
        </div>

        {/* Social Links */}
        <div className="cs-social">
          <span className="cs-social-label">{t.followUs}</span>
          <div className="cs-social-links">
            <a href="https://www.tiktok.com/@taealambh" target="_blank" rel="noopener noreferrer" className="cs-social-link">
              <TikTokIcon />
            </a>
            <a href="https://www.instagram.com/taealam.bh" target="_blank" rel="noopener noreferrer" className="cs-social-link">
              <InstagramIcon />
            </a>
            <a href="https://www.linkedin.com/company/taealam" target="_blank" rel="noopener noreferrer" className="cs-social-link">
              <LinkedInIcon />
            </a>
          </div>
        </div>

        {/* Button */}
        <button className="cs-btn" onClick={() => navigate('/')}>
          {t.backHome}
        </button>
      </div>
    </div>
  );
}
